<div id="fehlerbehandlung">
  <div *ngIf="error">
    <img src="assets/img/fehler.jpg">
    <strong>{{ error.msg }}</strong>
    <span>Status-Code: {{error.id}}</span>
  </div>
</div>